<template>
	<v-dialog v-model="dialog" max-width="500">
		<template v-slot:activator="{ on, attrs }">
			<v-btn color="secondary" class="ml-2" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-file-send-outline</v-icon>
				見積提出
			</v-btn>
		</template>

		<v-card>
			<v-toolbar dark color="primary" dense flat>
				<v-toolbar-title style="color: white" class="color-white"> 見積提出</v-toolbar-title>
				<v-spacer />
				<v-btn icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>
			<div class="pa-2">
				<p>見積を提出した日を入力してください</p>
				<v-menu
					:close-on-content-click="false"
					transition="scale-transition"
					offset-y
					min-width="auto"
				>
					<template v-slot:activator="{ on, attrs }">
						<v-text-field
							v-model="submitDate"
							label="見積提出日"
							class="mt-4"
							outlined
							dense
							readonly
							:rules="[rules.required]"
							v-bind="attrs"
							v-on="on"
						/>
					</template>
					<v-date-picker class="date-picker" v-model="submitDate" no-title locale="ja-JP" />
				</v-menu>
			</div>
			<v-card-actions>
				<v-row no-gutters class="mt-4">
					<v-col sm="3" cols="0" />
					<v-col sm="6" cols="12" class="text-center">
						<v-btn color="secondary" @click="submitForm">
							<v-icon class="mr-1">mdi-file-send-outline</v-icon>
              見積提出
						</v-btn>
					</v-col>
					<v-col sm="3" cols="0" class="text-right">
						<v-btn
							v-if="!$vuetify.breakpoint.xs"
							color="grey darken-1"
							text
							@click="dialog = false"
						>
							閉じる
						</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import axios from "axios"
import errorHandling from "../../../helper/errorHandling"
import authenticate from "../../../helper/authenticate"
import rules from "../../../helper/rules"

export default {
	props: {
		quotation: {
			type: Object,
			default: () => {
				return {}
			},
		},
	},
	data() {
		return {
			submitDate: "",
			dialog: false,
			rules,
		}
	},
	methods: {
		submitForm() {
			// 見積提出処理
			const headers = authenticate.setHeader()
			const url = `/erp/v1/quotations/${this.quotation.id}`
			const params = {}
			axios
				.put(url, params, { headers })
				.then((res) => {
					// TODO
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
					this.$emit("submit-quotation")
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
	},
}
</script>
